import { Item } from '@react-stately/collections'
import { Button } from 'blaze-ui/Button'
import { AlignLeft2, AlignRight2, AlignVerticalCenter } from 'blaze-ui/icons'
import { Menu } from 'components/Menu/Menu'
import { MenuTrigger } from 'components/MenuTrigger/MenuTrigger'
import { Key, useState } from 'react'

export type Alignment = 'left' | 'center' | 'right'

interface Props {
  value: Alignment
  onChange: (value: Alignment) => void
}

const icons = {
  left: AlignLeft2,
  center: AlignVerticalCenter,
  right: AlignRight2,
}

const labels = {
  left: 'Left',
  center: 'Center',
  right: 'Right',
}

export const AlignmentButton = ({ value = 'center', onChange }: Props) => {
  const [isOpen, setIsOpen] = useState(false)
  const handleAction = (key: Key) => {
    onChange(key as Alignment)
  }

  return (
    <MenuTrigger onOpenChange={setIsOpen}>
      <Button
        size="sm"
        variant="editor"
        preventFocusOnPress
        frontIcon={icons[value]}
        withChevron={isOpen ? 'up' : 'down'}
        aria-label={`Alignment: ${value}`}
      >
        {labels[value]}
      </Button>
      <Menu selectionMode="single" selectedKeys={new Set([value])} onAction={handleAction}>
        <Item key="left" textValue="Left">
          <AlignLeft2 /> Left
        </Item>
        <Item key="center" textValue="Center">
          <AlignVerticalCenter /> Center
        </Item>
        <Item key="right" textValue="Right">
          <AlignRight2 /> Right
        </Item>
      </Menu>
    </MenuTrigger>
  )
}
